module.exports = __webpack_public_path__ + "img/limit_icon.e8d6b6e8.svg";